<template>
    <div class="app-container">
        <el-row>
            <el-date-picker v-model="dateList" style="min-width:400px;margin-right:10px;" type="daterange"
                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                clearable></el-date-picker>

            <el-input style="max-width:200px; margin-right: 10px;" v-model="listQuery.name" placeholder="用户姓名/奖品名"
                clearable />

            <el-select style="margin-right: 10px;" v-model="listQuery.type" placeholder="奖品类型" clearable>
                <el-option v-for="item in filterSettings.itemTypeSelectOptions" :key="item.value" :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>

            <el-select style="margin-right: 10px;" v-model="listQuery.state" placeholder="状态" clearable>
                <el-option v-for="item in filterSettings.stateSelectOptions" :key="item.value" :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
            <el-button type="primary" icon="el-icon-search" :loading="listLoading" @click="handleSearch">搜索</el-button>
            <el-button type="warning" icon="el-icon-upload2" :loading="listLoading" @click="exportExcel">导出Excel</el-button>
        </el-row>
        <div class="table">
            <el-table v-loading="listLoading" :data="tableData" border fit highlight-current-row height="65vh">
                <el-table-column type="index" label="序号" width="95" align="center" />
                <el-table-column prop="picture" label="图片" min-width="120" align="center">
                    <template #default="{ row: { img } }">
                        <el-image v-if="img" style="width: 100px; height: 100px" :src="img" fit="cover" />
                    </template>
                </el-table-column>
                <el-table-column prop="draw_name" label="名称" min-width="110" align="center" />
                <el-table-column label="奖品类型" min-width="110" align="center">
                    <template #default="{ row: { type } }">
                        <el-tag size="medium">{{ checkType(type) }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="user_info.head_img" label="用户头像" min-width="120" align="center">
                    <template #default="{ row: { user_info: { head_img } } }">
                        <el-image style="width: 100px; height: 100px" :src="head_img" fit="cover" />
                    </template>
                </el-table-column>
                <el-table-column prop="user_info.name" label="用户昵称" min-width="110" align="center" />
                <el-table-column prop="created_at" label="抽奖时间" min-width="110" align="center" />
                <el-table-column label="状态" min-width="110" align="center">
                    <template #default="{ row: { state } }">
                        <el-tag :type="checkState(state).type" size="medium">{{ checkState(state).txt }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="300" align="center" fixed="right">
                    <template #default="{ row }">
                        <div v-if="row.type == 2">
                            <el-button v-if="[1, 2, 3].includes(Number(row.state))" size="mini"
                                @click="handleShowAddress(row.user_address_log)" :loading="btnLoading">
                                查看地址
                            </el-button>
                            <el-button v-if="row.state == 2" size="mini" type="primary" @click="handleModal(row)"
                                :loading="btnLoading">点击发货</el-button>
                            <el-button v-if="row.state == 3" size="mini" type="primary" @click="handleSign(row.id)"
                                :loading="btnLoading">签收</el-button>
                            <el-button v-if="[1, 3].includes(Number(row.state))" size="mini" type="warning"
                                @click="handleModal(row)" :loading="btnLoading">
                                物流单号
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination-container">
                <el-pagination :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
                    :total="total" background layout="total, sizes, prev, pager, next, jumper"
                    @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </div>

        <shipment-action-modal :show.sync="logisticVisible" :isEdit="editData.isEdit" :logisticsData="editData"
            @success="getList" />
        <address-show :show.sync="addressVisible" :addressData="editData" @closeShow="addressVisible = false" />
    </div>
</template>

<script>
// 抽奖管理-中奖名单
import ShipmentActionModal from './components/ShipmentActionModal.vue';
import AddressShow from './components/AddressShow.vue';
import { lucky } from "@/api/draw"
import * as XLSX from "xlsx"

export default {
    data: () => ({
        filterSettings: {
            stateSelectOptions: [
                {
                    value: 0,
                    label: '待提交地址'
                },
                {
                    value: 2,
                    label: '待发货'
                },
                {
                    value: 3,
                    label: '已寄出'
                },
                {
                    value: 1,
                    label: '已完成'
                },
            ],
            itemTypeSelectOptions: [
                {
                    value: 1,
                    label: "积分"
                },
                {
                    value: 2,
                    label: "实物"
                },
                // {
                //     value: 3,
                //     label: "谢谢惠顾"
                // }
            ]
        },
        listLoading: false,
        btnLoading: false,
        tableData: [],
        total: null,
        listQuery: {
            page: 1,
            limit: 10,
            name: '',
            type: null,
            state: null,
            start_at: "",
            end_at: ""
        },
        modalType: 'add',
        logisticVisible: false,
        editData: {
            id: '',
            logistics_name: '',
            logistics_number: '',
            idEdit: false
        },
        addressVisible: false,
        dateList: []
    }),
    components: {
        ShipmentActionModal,
        AddressShow
    },
    methods: {
        getList() {
            this.listLoading = true
            this.tableData = []
            lucky.list(this.listQuery).then(({ data }) => {
                this.tableData = data.data;
                this.total = data.total;
                this.listLoading = false;
            })
        },
        // 搜索
        handleSearch() {
            this.listQuery.page = 1
            this.getList()
        },
        // 表格操作
        handleEditTable(e) {
            this.setModalType('edit')
            this.editData = e
            this.logisticVisible = true
        },
        handleForbid() { },
        // 分页操作
        handleSizeChange(limit) {
            this.listQuery.limit = limit
            this.getList()
        },
        handleCurrentChange(page) {
            this.listQuery.page = page
            this.getList()
        },
        // 更改模式
        setModalType(type) {
            this.modalType = type
        },
        // 添加数据
        handleAddTable() {
            this.setModalType('add')
            this.logisticVisible = true
        },
        //添加/查看物流信息
        handleModal(data) {
            const { id, logistics_name, logistics_number, state } = data
            this.editData = { id, logistics_name, logistics_number, isEdit: state == 2 ? true : false }
            this.logisticVisible = true
        },
        //展示地址弹窗
        handleShowAddress(data) {
            // return console.log('row',data)
            this.editData = data
            this.addressVisible = true
        },
        //签收
        handleSign(id) {
            this.btnLoading = true
            lucky.sign(id).then(res => {
                console.log(res)
                this.$message({
                    message: '签收成功',
                    type: 'success'
                })
                this.btnLoading = false
                this.getList()
            }).catch(err => {
                this.btnLoading = false
                console.log('失败', err)
            })
        },
        checkState(state) {
            // console.log('状态',state)
            switch (Number(state)) {
                case 0: return { txt: '待填写地址', type: 'info' };
                case 1: return { txt: '已完成', type: 'success' };
                case 2: return { txt: '待发货', type: 'warning' };
                case 3: return { txt: '已发货', type: 'primary' };
            }
        },
        checkType(state) {
            switch (Number(state)) {
                case 1: return '积分';
                case 2: return '实物';
                case 3: return '谢谢惠顾';
            }
        },
        // 导出Excel
        async exportExcel() {
            console.log('exportExcel')
            // +++修改excel-抽奖管理-中奖名单-附件5---ok
            const { total } = this
            if (!total) return

            try {
                const { data: { data: reqData } } = await lucky.exportLuckyExcel({ ...this.listQuery, page: 1, limit: 99999999999 })
                console.log(reqData);
                var wb = XLSX.utils.book_new();

                var excelData = [
                    ['序号', '名称', '奖品类型', '收货人', '手机号码', '地址', '邮编', '物流公司', '物流编码', '用户昵称', '性別', '年龄', '手机号', '居住地-国家', '居住地-省份', '微信ID', '邮箱', '擅长领域', '消耗积分', '抽奖时间', '状态'],
                    ...reqData.map((item, index) => [
                        index + 1,
                        item.draw_name,
                        item.type === 1 ? '积分' : item.type === 2 ? '实物' : '其它',
                        item.user_address_log ? item.user_address_log.user_name : '',
                        item.user_address_log ? item.user_address_log.user_phone : '',
                        item.user_address_log ? item.user_address_log.address_details : '',
                        item.user_address_log ? item.user_address_log.postal_code : '',
                        item.logistics_name,
                        item.logistics_number,
                        item.user_info.name,
                        item.user_info.gender === 1 ? '男性' : item.user_info.gender === 2 ? '女性' : '未设置',
                        item.user_info.age_group === 1 ? '20岁以下' : item.user_info.age_group === 2 ? '21~30岁' : item.user_info.age_group === 3 ? '31~40岁' : item.user_info.age_group === 4 ? '41~50岁' : item.user_info.age_group === 5 ? '51岁以上' : '未设置',
                        item.user_info.account,
                        item.user_info.country,
                        item.user_info.provinces,
                        item.user_info.wx_id,
                        item.user_info.email,
                        item.user_info.evaluation_type_field.length > 0 ? item.user_info.evaluation_type_field.map(item => item.name).join(',') : '',
                        item.draw_type === 1 ? '抽奖次数1' : item.draw_type === 2 ? `${item.integral}积分` : '',
                        item.created_at,
                        item.state === 0 ? '待填写地址' : item.state === 1 ? '已完成' : item.state === 2 ? '待发货' : item.state === 3 ? '已发货' : '无字段'
                    ])
                ];
                var ws = XLSX.utils.aoa_to_sheet(excelData);
                XLSX.utils.book_append_sheet(wb, ws, "中奖名单");
                XLSX.writeFile(wb, "抽奖管理-中奖名单.xlsx");

                this.$notify.info({
                    title: '消息',
                    message: '请等待, 正在生成Excel表格文件...'
                });
            } catch {
                this.$notify.error({
                    title: '错误',
                    message: '获取数据错误!'
                });
            }
        }
    },
    beforeMount() {
        this.getList()
    },
    watch: {
        dateList: {
            handler(nval) {
                if (nval) {
                    this.listQuery.start_at = nval[0]
                    this.listQuery.end_at = `${nval[1]} 23:59`
                } else {
                    this.listQuery.start_at = this.listQuery.end_at = ''
                }
            },
            deep: true
        }
    }
}
</script>

<style scoped lang="scss" scoped>
.table {
    margin-top: 10px;
}
</style>